/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as booking_platformV1Shared000 from '../../../external/mercury/v1/shared/price-details.pb';
import * as booking_platformV1Shared001 from '../../../external/mercury/v1/shared/cancellation-policy.pb';
import * as booking_platformV1Shared002 from '../../../external/mercury/v1/shared/contact-info.pb';
import * as booking_platformV1Shared003 from '../../../external/mercury/v1/shared/payment-session.pb';
import * as booking_platformV1Shared004 from '../../../external/mercury/v1/shared/checkout-list-item.pb';
import * as booking_platformV1Shared005 from '../../../external/mercury/v1/shared/booking-question-answer.pb';
import * as booking_platformV1Shared006 from '../../../external/mercury/v1/shared/booking-question-validation-error.pb';
import * as booking_platformV1Shared007 from '../../../external/mercury/v1/shared/request-property-validation-error.pb';
import * as booking_platformV1Shared008 from '../../../external/mercury/v1/shared/booking-session-status.pb';
import * as googleProtobuf009 from '@ngx-grpc/well-known-types';
import * as googleType010 from '../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as booking_platformV1Shared011 from '../../../external/mercury/v1/shared/booking-component-detail.pb';
import * as booking_platformV1Shared012 from '../../../external/mercury/v1/shared/booking-status.pb';
import * as booking_platformV1Shared013 from '../../../external/mercury/v1/shared/customer-cancellation-reason.pb';
import * as booking_platformV1Shared014 from '../../../external/mercury/v1/shared/cancellation-status.pb';
import * as booking_platformV1AttractionCommon015 from '../../../external/mercury/v1/attraction/common/product-detail.pb';
import * as booking_platformV1Shared016 from '../../../external/mercury/v1/shared/guest-configuration.pb';
import * as booking_platformV1Shared017 from '../../../external/mercury/v1/shared/product-availability-range.pb';
import * as booking_platformV1AttractionCommon018 from '../../../external/mercury/v1/attraction/common/attraction-product-option.pb';
import * as booking_platformV1Shared019 from '../../../external/mercury/v1/shared/geolocation.pb';
import * as booking_platformV1Shared020 from '../../../external/mercury/v1/shared/auto-complete-result-item.pb';
import * as booking_platformV1Shared021 from '../../../external/mercury/v1/shared/seat.pb';
import * as booking_platformV1Shared022 from '../../../external/mercury/v1/shared/benefit-item.pb';
import * as googleProtobuf023 from '@ngx-grpc/well-known-types';
import * as booking_platformV1024 from '../../../external/mercury/v1/booking-flow.pb';
import * as booking_platformV1Attraction025 from '../../../external/mercury/v1/attraction/attraction.pb';
import * as booking_platformV1Entertainment026 from '../../../external/mercury/v1/entertainment/entertainment.pb';
import * as booking_platformV1Dining027 from '../../../external/mercury/v1/dining/dining.pb';
/**
 * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetailsResponse
 */
export class MercuryHubBookingDetailsResponse implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.MercuryHubBookingDetailsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MercuryHubBookingDetailsResponse();
    MercuryHubBookingDetailsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MercuryHubBookingDetailsResponse) {
    _instance.bookings = _instance.bookings || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MercuryHubBookingDetailsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new MercuryHubBookingDetail();
          _reader.readMessage(
            messageInitializer1,
            MercuryHubBookingDetail.deserializeBinaryFromReader
          );
          (_instance.bookings = _instance.bookings || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    MercuryHubBookingDetailsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MercuryHubBookingDetailsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.bookings && _instance.bookings.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.bookings as any,
        MercuryHubBookingDetail.serializeBinaryToWriter
      );
    }
  }

  private _bookings?: MercuryHubBookingDetail[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MercuryHubBookingDetailsResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<MercuryHubBookingDetailsResponse.AsObject>
  ) {
    _value = _value || {};
    this.bookings = (_value.bookings || []).map(
      m => new MercuryHubBookingDetail(m)
    );
    MercuryHubBookingDetailsResponse.refineValues(this);
  }
  get bookings(): MercuryHubBookingDetail[] | undefined {
    return this._bookings;
  }
  set bookings(value: MercuryHubBookingDetail[] | undefined) {
    this._bookings = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MercuryHubBookingDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MercuryHubBookingDetailsResponse.AsObject {
    return {
      bookings: (this.bookings || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MercuryHubBookingDetailsResponse.AsProtobufJSON {
    return {
      bookings: (this.bookings || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module MercuryHubBookingDetailsResponse {
  /**
   * Standard JavaScript object representation for MercuryHubBookingDetailsResponse
   */
  export interface AsObject {
    bookings?: MercuryHubBookingDetail.AsObject[];
  }

  /**
   * Protobuf JSON representation for MercuryHubBookingDetailsResponse
   */
  export interface AsProtobufJSON {
    bookings: MercuryHubBookingDetail.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetail
 */
export class MercuryHubBookingDetail implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.MercuryHubBookingDetail';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MercuryHubBookingDetail();
    MercuryHubBookingDetail.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MercuryHubBookingDetail) {
    _instance.bookingReference = _instance.bookingReference || '';
    _instance.bookingDetail = _instance.bookingDetail || undefined;
    _instance.attractionInfo = _instance.attractionInfo || {};
    _instance.venueInfo = _instance.venueInfo || {};
    _instance.eventInfo = _instance.eventInfo || {};
    _instance.performerInfo = _instance.performerInfo || {};
    _instance.diningInfo = _instance.diningInfo || {};
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MercuryHubBookingDetail,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingReference = _reader.readString();
          break;
        case 2:
          _instance.bookingDetail = new booking_platformV1024.BookingDetailsResponseItem();
          _reader.readMessage(
            _instance.bookingDetail,
            booking_platformV1024.BookingDetailsResponseItem
              .deserializeBinaryFromReader
          );
          break;
        case 3:
          const msg_3 = {} as any;
          _reader.readMessage(
            msg_3,
            MercuryHubBookingDetail.AttractionInfoEntry
              .deserializeBinaryFromReader
          );
          _instance.attractionInfo = _instance.attractionInfo || {};
          _instance.attractionInfo[Number(msg_3.key)] = msg_3.value;
          break;
        case 4:
          const msg_4 = {} as any;
          _reader.readMessage(
            msg_4,
            MercuryHubBookingDetail.VenueInfoEntry.deserializeBinaryFromReader
          );
          _instance.venueInfo = _instance.venueInfo || {};
          _instance.venueInfo[Number(msg_4.key)] = msg_4.value;
          break;
        case 5:
          const msg_5 = {} as any;
          _reader.readMessage(
            msg_5,
            MercuryHubBookingDetail.EventInfoEntry.deserializeBinaryFromReader
          );
          _instance.eventInfo = _instance.eventInfo || {};
          _instance.eventInfo[Number(msg_5.key)] = msg_5.value;
          break;
        case 6:
          const msg_6 = {} as any;
          _reader.readMessage(
            msg_6,
            MercuryHubBookingDetail.PerformerInfoEntry
              .deserializeBinaryFromReader
          );
          _instance.performerInfo = _instance.performerInfo || {};
          _instance.performerInfo[Number(msg_6.key)] = msg_6.value;
          break;
        case 7:
          const msg_7 = {} as any;
          _reader.readMessage(
            msg_7,
            MercuryHubBookingDetail.DiningInfoEntry.deserializeBinaryFromReader
          );
          _instance.diningInfo = _instance.diningInfo || {};
          _instance.diningInfo[Number(msg_7.key)] = msg_7.value;
          break;
        default:
          _reader.skipField();
      }
    }

    MercuryHubBookingDetail.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MercuryHubBookingDetail,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingReference) {
      _writer.writeString(1, _instance.bookingReference);
    }
    if (_instance.bookingDetail) {
      _writer.writeMessage(
        2,
        _instance.bookingDetail as any,
        booking_platformV1024.BookingDetailsResponseItem.serializeBinaryToWriter
      );
    }
    if (!!_instance.attractionInfo) {
      const keys_3 = Object.keys(_instance.attractionInfo as any);

      if (keys_3.length) {
        const repeated_3 = keys_3
          .map(key => ({
            key: Number(key),
            value: (_instance.attractionInfo as any)[key]
          }))
          .reduce((r, v) => [...r, v], [] as any[]);

        _writer.writeRepeatedMessage(
          3,
          repeated_3,
          MercuryHubBookingDetail.AttractionInfoEntry.serializeBinaryToWriter
        );
      }
    }
    if (!!_instance.venueInfo) {
      const keys_4 = Object.keys(_instance.venueInfo as any);

      if (keys_4.length) {
        const repeated_4 = keys_4
          .map(key => ({
            key: Number(key),
            value: (_instance.venueInfo as any)[key]
          }))
          .reduce((r, v) => [...r, v], [] as any[]);

        _writer.writeRepeatedMessage(
          4,
          repeated_4,
          MercuryHubBookingDetail.VenueInfoEntry.serializeBinaryToWriter
        );
      }
    }
    if (!!_instance.eventInfo) {
      const keys_5 = Object.keys(_instance.eventInfo as any);

      if (keys_5.length) {
        const repeated_5 = keys_5
          .map(key => ({
            key: Number(key),
            value: (_instance.eventInfo as any)[key]
          }))
          .reduce((r, v) => [...r, v], [] as any[]);

        _writer.writeRepeatedMessage(
          5,
          repeated_5,
          MercuryHubBookingDetail.EventInfoEntry.serializeBinaryToWriter
        );
      }
    }
    if (!!_instance.performerInfo) {
      const keys_6 = Object.keys(_instance.performerInfo as any);

      if (keys_6.length) {
        const repeated_6 = keys_6
          .map(key => ({
            key: Number(key),
            value: (_instance.performerInfo as any)[key]
          }))
          .reduce((r, v) => [...r, v], [] as any[]);

        _writer.writeRepeatedMessage(
          6,
          repeated_6,
          MercuryHubBookingDetail.PerformerInfoEntry.serializeBinaryToWriter
        );
      }
    }
    if (!!_instance.diningInfo) {
      const keys_7 = Object.keys(_instance.diningInfo as any);

      if (keys_7.length) {
        const repeated_7 = keys_7
          .map(key => ({
            key: Number(key),
            value: (_instance.diningInfo as any)[key]
          }))
          .reduce((r, v) => [...r, v], [] as any[]);

        _writer.writeRepeatedMessage(
          7,
          repeated_7,
          MercuryHubBookingDetail.DiningInfoEntry.serializeBinaryToWriter
        );
      }
    }
  }

  private _bookingReference: string;
  private _bookingDetail?: booking_platformV1024.BookingDetailsResponseItem;
  private _attractionInfo: {
    [prop: number]: booking_platformV1Attraction025.AttractionInfoResponseItem;
  };
  private _venueInfo: {
    [prop: number]: booking_platformV1Entertainment026.VenueInfoEntity;
  };
  private _eventInfo: {
    [prop: number]: booking_platformV1Entertainment026.EventInfoEntity;
  };
  private _performerInfo: {
    [prop: number]: booking_platformV1Entertainment026.PerformerInfoEntity;
  };
  private _diningInfo: {
    [prop: number]: booking_platformV1Dining027.VenueDetailsEntity;
  };

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MercuryHubBookingDetail to deeply clone from
   */
  constructor(_value?: RecursivePartial<MercuryHubBookingDetail.AsObject>) {
    _value = _value || {};
    this.bookingReference = _value.bookingReference;
    this.bookingDetail = _value.bookingDetail
      ? new booking_platformV1024.BookingDetailsResponseItem(
          _value.bookingDetail
        )
      : undefined;
    (this.attractionInfo = _value!.attractionInfo
      ? Object.keys(_value!.attractionInfo).reduce(
          (r, k) => ({
            ...r,
            [k]: _value!.attractionInfo![k]
              ? new booking_platformV1Attraction025.AttractionInfoResponseItem(
                  _value!.attractionInfo![k]
                )
              : undefined
          }),
          {}
        )
      : {}),
      (this.venueInfo = _value!.venueInfo
        ? Object.keys(_value!.venueInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: _value!.venueInfo![k]
                ? new booking_platformV1Entertainment026.VenueInfoEntity(
                    _value!.venueInfo![k]
                  )
                : undefined
            }),
            {}
          )
        : {}),
      (this.eventInfo = _value!.eventInfo
        ? Object.keys(_value!.eventInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: _value!.eventInfo![k]
                ? new booking_platformV1Entertainment026.EventInfoEntity(
                    _value!.eventInfo![k]
                  )
                : undefined
            }),
            {}
          )
        : {}),
      (this.performerInfo = _value!.performerInfo
        ? Object.keys(_value!.performerInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: _value!.performerInfo![k]
                ? new booking_platformV1Entertainment026.PerformerInfoEntity(
                    _value!.performerInfo![k]
                  )
                : undefined
            }),
            {}
          )
        : {}),
      (this.diningInfo = _value!.diningInfo
        ? Object.keys(_value!.diningInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: _value!.diningInfo![k]
                ? new booking_platformV1Dining027.VenueDetailsEntity(
                    _value!.diningInfo![k]
                  )
                : undefined
            }),
            {}
          )
        : {}),
      MercuryHubBookingDetail.refineValues(this);
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }
  get bookingDetail():
    | booking_platformV1024.BookingDetailsResponseItem
    | undefined {
    return this._bookingDetail;
  }
  set bookingDetail(
    value: booking_platformV1024.BookingDetailsResponseItem | undefined
  ) {
    this._bookingDetail = value;
  }
  get attractionInfo(): {
    [prop: number]: booking_platformV1Attraction025.AttractionInfoResponseItem;
  } {
    return this._attractionInfo;
  }
  set attractionInfo(value: {
    [prop: number]: booking_platformV1Attraction025.AttractionInfoResponseItem;
  }) {
    this._attractionInfo = value;
  }
  get venueInfo(): {
    [prop: number]: booking_platformV1Entertainment026.VenueInfoEntity;
  } {
    return this._venueInfo;
  }
  set venueInfo(value: {
    [prop: number]: booking_platformV1Entertainment026.VenueInfoEntity;
  }) {
    this._venueInfo = value;
  }
  get eventInfo(): {
    [prop: number]: booking_platformV1Entertainment026.EventInfoEntity;
  } {
    return this._eventInfo;
  }
  set eventInfo(value: {
    [prop: number]: booking_platformV1Entertainment026.EventInfoEntity;
  }) {
    this._eventInfo = value;
  }
  get performerInfo(): {
    [prop: number]: booking_platformV1Entertainment026.PerformerInfoEntity;
  } {
    return this._performerInfo;
  }
  set performerInfo(value: {
    [prop: number]: booking_platformV1Entertainment026.PerformerInfoEntity;
  }) {
    this._performerInfo = value;
  }
  get diningInfo(): {
    [prop: number]: booking_platformV1Dining027.VenueDetailsEntity;
  } {
    return this._diningInfo;
  }
  set diningInfo(value: {
    [prop: number]: booking_platformV1Dining027.VenueDetailsEntity;
  }) {
    this._diningInfo = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MercuryHubBookingDetail.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MercuryHubBookingDetail.AsObject {
    return {
      bookingReference: this.bookingReference,
      bookingDetail: this.bookingDetail
        ? this.bookingDetail.toObject()
        : undefined,
      attractionInfo: this.attractionInfo
        ? Object.keys(this.attractionInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.attractionInfo![k]
                ? this.attractionInfo![k].toObject()
                : undefined
            }),
            {}
          )
        : {},
      venueInfo: this.venueInfo
        ? Object.keys(this.venueInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.venueInfo![k]
                ? this.venueInfo![k].toObject()
                : undefined
            }),
            {}
          )
        : {},
      eventInfo: this.eventInfo
        ? Object.keys(this.eventInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.eventInfo![k]
                ? this.eventInfo![k].toObject()
                : undefined
            }),
            {}
          )
        : {},
      performerInfo: this.performerInfo
        ? Object.keys(this.performerInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.performerInfo![k]
                ? this.performerInfo![k].toObject()
                : undefined
            }),
            {}
          )
        : {},
      diningInfo: this.diningInfo
        ? Object.keys(this.diningInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.diningInfo![k]
                ? this.diningInfo![k].toObject()
                : undefined
            }),
            {}
          )
        : {}
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MercuryHubBookingDetail.AsProtobufJSON {
    return {
      bookingReference: this.bookingReference,
      bookingDetail: this.bookingDetail
        ? this.bookingDetail.toProtobufJSON(options)
        : null,
      attractionInfo: this.attractionInfo
        ? Object.keys(this.attractionInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.attractionInfo![k]
                ? this.attractionInfo![k].toJSON()
                : null
            }),
            {}
          )
        : {},
      venueInfo: this.venueInfo
        ? Object.keys(this.venueInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.venueInfo![k] ? this.venueInfo![k].toJSON() : null
            }),
            {}
          )
        : {},
      eventInfo: this.eventInfo
        ? Object.keys(this.eventInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.eventInfo![k] ? this.eventInfo![k].toJSON() : null
            }),
            {}
          )
        : {},
      performerInfo: this.performerInfo
        ? Object.keys(this.performerInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.performerInfo![k]
                ? this.performerInfo![k].toJSON()
                : null
            }),
            {}
          )
        : {},
      diningInfo: this.diningInfo
        ? Object.keys(this.diningInfo).reduce(
            (r, k) => ({
              ...r,
              [k]: this.diningInfo![k] ? this.diningInfo![k].toJSON() : null
            }),
            {}
          )
        : {}
    };
  }
}
export module MercuryHubBookingDetail {
  /**
   * Standard JavaScript object representation for MercuryHubBookingDetail
   */
  export interface AsObject {
    bookingReference: string;
    bookingDetail?: booking_platformV1024.BookingDetailsResponseItem.AsObject;
    attractionInfo: {
      [prop: number]: booking_platformV1Attraction025.AttractionInfoResponseItem;
    };
    venueInfo: {
      [prop: number]: booking_platformV1Entertainment026.VenueInfoEntity;
    };
    eventInfo: {
      [prop: number]: booking_platformV1Entertainment026.EventInfoEntity;
    };
    performerInfo: {
      [prop: number]: booking_platformV1Entertainment026.PerformerInfoEntity;
    };
    diningInfo: {
      [prop: number]: booking_platformV1Dining027.VenueDetailsEntity;
    };
  }

  /**
   * Protobuf JSON representation for MercuryHubBookingDetail
   */
  export interface AsProtobufJSON {
    bookingReference: string;
    bookingDetail: booking_platformV1024.BookingDetailsResponseItem.AsProtobufJSON | null;
    attractionInfo: {
      [prop: number]: booking_platformV1Attraction025.AttractionInfoResponseItem;
    };
    venueInfo: {
      [prop: number]: booking_platformV1Entertainment026.VenueInfoEntity;
    };
    eventInfo: {
      [prop: number]: booking_platformV1Entertainment026.EventInfoEntity;
    };
    performerInfo: {
      [prop: number]: booking_platformV1Entertainment026.PerformerInfoEntity;
    };
    diningInfo: {
      [prop: number]: booking_platformV1Dining027.VenueDetailsEntity;
    };
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetail.AttractionInfoEntry
   */
  export class AttractionInfoEntry implements GrpcMessage {
    static id =
      'ten.grpc.booking_service.dto.MercuryHubBookingDetail.AttractionInfoEntry';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new AttractionInfoEntry();
      AttractionInfoEntry.deserializeBinaryFromReader(
        instance,
        new BinaryReader(bytes)
      );
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: AttractionInfoEntry) {
      _instance.key = _instance.key || 0;
      _instance.value = _instance.value || undefined;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: AttractionInfoEntry,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.key = _reader.readInt32();
            break;
          case 2:
            _instance.value = new booking_platformV1Attraction025.AttractionInfoResponseItem();
            _reader.readMessage(
              _instance.value,
              booking_platformV1Attraction025.AttractionInfoResponseItem
                .deserializeBinaryFromReader
            );
            break;
          default:
            _reader.skipField();
        }
      }

      AttractionInfoEntry.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(
      _instance: AttractionInfoEntry,
      _writer: BinaryWriter
    ) {
      if (_instance.key) {
        _writer.writeInt32(1, _instance.key);
      }
      if (_instance.value) {
        _writer.writeMessage(
          2,
          _instance.value as any,
          booking_platformV1Attraction025.AttractionInfoResponseItem
            .serializeBinaryToWriter
        );
      }
    }

    private _key: number;
    private _value?: booking_platformV1Attraction025.AttractionInfoResponseItem;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of AttractionInfoEntry to deeply clone from
     */
    constructor(_value?: RecursivePartial<AttractionInfoEntry.AsObject>) {
      _value = _value || {};
      this.key = _value.key;
      this.value = _value.value
        ? new booking_platformV1Attraction025.AttractionInfoResponseItem(
            _value.value
          )
        : undefined;
      AttractionInfoEntry.refineValues(this);
    }
    get key(): number {
      return this._key;
    }
    set key(value: number) {
      this._key = value;
    }
    get value():
      | booking_platformV1Attraction025.AttractionInfoResponseItem
      | undefined {
      return this._value;
    }
    set value(
      value:
        | booking_platformV1Attraction025.AttractionInfoResponseItem
        | undefined
    ) {
      this._value = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      AttractionInfoEntry.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): AttractionInfoEntry.AsObject {
      return {
        key: this.key,
        value: this.value ? this.value.toObject() : undefined
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): AttractionInfoEntry.AsProtobufJSON {
      return {
        key: this.key,
        value: this.value ? this.value.toProtobufJSON(options) : null
      };
    }
  }
  export module AttractionInfoEntry {
    /**
     * Standard JavaScript object representation for AttractionInfoEntry
     */
    export interface AsObject {
      key: number;
      value?: booking_platformV1Attraction025.AttractionInfoResponseItem.AsObject;
    }

    /**
     * Protobuf JSON representation for AttractionInfoEntry
     */
    export interface AsProtobufJSON {
      key: number;
      value: booking_platformV1Attraction025.AttractionInfoResponseItem.AsProtobufJSON | null;
    }
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetail.VenueInfoEntry
   */
  export class VenueInfoEntry implements GrpcMessage {
    static id =
      'ten.grpc.booking_service.dto.MercuryHubBookingDetail.VenueInfoEntry';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new VenueInfoEntry();
      VenueInfoEntry.deserializeBinaryFromReader(
        instance,
        new BinaryReader(bytes)
      );
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: VenueInfoEntry) {
      _instance.key = _instance.key || 0;
      _instance.value = _instance.value || undefined;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: VenueInfoEntry,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.key = _reader.readInt32();
            break;
          case 2:
            _instance.value = new booking_platformV1Entertainment026.VenueInfoEntity();
            _reader.readMessage(
              _instance.value,
              booking_platformV1Entertainment026.VenueInfoEntity
                .deserializeBinaryFromReader
            );
            break;
          default:
            _reader.skipField();
        }
      }

      VenueInfoEntry.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(
      _instance: VenueInfoEntry,
      _writer: BinaryWriter
    ) {
      if (_instance.key) {
        _writer.writeInt32(1, _instance.key);
      }
      if (_instance.value) {
        _writer.writeMessage(
          2,
          _instance.value as any,
          booking_platformV1Entertainment026.VenueInfoEntity
            .serializeBinaryToWriter
        );
      }
    }

    private _key: number;
    private _value?: booking_platformV1Entertainment026.VenueInfoEntity;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of VenueInfoEntry to deeply clone from
     */
    constructor(_value?: RecursivePartial<VenueInfoEntry.AsObject>) {
      _value = _value || {};
      this.key = _value.key;
      this.value = _value.value
        ? new booking_platformV1Entertainment026.VenueInfoEntity(_value.value)
        : undefined;
      VenueInfoEntry.refineValues(this);
    }
    get key(): number {
      return this._key;
    }
    set key(value: number) {
      this._key = value;
    }
    get value():
      | booking_platformV1Entertainment026.VenueInfoEntity
      | undefined {
      return this._value;
    }
    set value(
      value: booking_platformV1Entertainment026.VenueInfoEntity | undefined
    ) {
      this._value = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      VenueInfoEntry.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): VenueInfoEntry.AsObject {
      return {
        key: this.key,
        value: this.value ? this.value.toObject() : undefined
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): VenueInfoEntry.AsProtobufJSON {
      return {
        key: this.key,
        value: this.value ? this.value.toProtobufJSON(options) : null
      };
    }
  }
  export module VenueInfoEntry {
    /**
     * Standard JavaScript object representation for VenueInfoEntry
     */
    export interface AsObject {
      key: number;
      value?: booking_platformV1Entertainment026.VenueInfoEntity.AsObject;
    }

    /**
     * Protobuf JSON representation for VenueInfoEntry
     */
    export interface AsProtobufJSON {
      key: number;
      value: booking_platformV1Entertainment026.VenueInfoEntity.AsProtobufJSON | null;
    }
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetail.EventInfoEntry
   */
  export class EventInfoEntry implements GrpcMessage {
    static id =
      'ten.grpc.booking_service.dto.MercuryHubBookingDetail.EventInfoEntry';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new EventInfoEntry();
      EventInfoEntry.deserializeBinaryFromReader(
        instance,
        new BinaryReader(bytes)
      );
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: EventInfoEntry) {
      _instance.key = _instance.key || 0;
      _instance.value = _instance.value || undefined;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: EventInfoEntry,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.key = _reader.readInt32();
            break;
          case 2:
            _instance.value = new booking_platformV1Entertainment026.EventInfoEntity();
            _reader.readMessage(
              _instance.value,
              booking_platformV1Entertainment026.EventInfoEntity
                .deserializeBinaryFromReader
            );
            break;
          default:
            _reader.skipField();
        }
      }

      EventInfoEntry.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(
      _instance: EventInfoEntry,
      _writer: BinaryWriter
    ) {
      if (_instance.key) {
        _writer.writeInt32(1, _instance.key);
      }
      if (_instance.value) {
        _writer.writeMessage(
          2,
          _instance.value as any,
          booking_platformV1Entertainment026.EventInfoEntity
            .serializeBinaryToWriter
        );
      }
    }

    private _key: number;
    private _value?: booking_platformV1Entertainment026.EventInfoEntity;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of EventInfoEntry to deeply clone from
     */
    constructor(_value?: RecursivePartial<EventInfoEntry.AsObject>) {
      _value = _value || {};
      this.key = _value.key;
      this.value = _value.value
        ? new booking_platformV1Entertainment026.EventInfoEntity(_value.value)
        : undefined;
      EventInfoEntry.refineValues(this);
    }
    get key(): number {
      return this._key;
    }
    set key(value: number) {
      this._key = value;
    }
    get value():
      | booking_platformV1Entertainment026.EventInfoEntity
      | undefined {
      return this._value;
    }
    set value(
      value: booking_platformV1Entertainment026.EventInfoEntity | undefined
    ) {
      this._value = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      EventInfoEntry.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): EventInfoEntry.AsObject {
      return {
        key: this.key,
        value: this.value ? this.value.toObject() : undefined
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): EventInfoEntry.AsProtobufJSON {
      return {
        key: this.key,
        value: this.value ? this.value.toProtobufJSON(options) : null
      };
    }
  }
  export module EventInfoEntry {
    /**
     * Standard JavaScript object representation for EventInfoEntry
     */
    export interface AsObject {
      key: number;
      value?: booking_platformV1Entertainment026.EventInfoEntity.AsObject;
    }

    /**
     * Protobuf JSON representation for EventInfoEntry
     */
    export interface AsProtobufJSON {
      key: number;
      value: booking_platformV1Entertainment026.EventInfoEntity.AsProtobufJSON | null;
    }
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetail.PerformerInfoEntry
   */
  export class PerformerInfoEntry implements GrpcMessage {
    static id =
      'ten.grpc.booking_service.dto.MercuryHubBookingDetail.PerformerInfoEntry';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new PerformerInfoEntry();
      PerformerInfoEntry.deserializeBinaryFromReader(
        instance,
        new BinaryReader(bytes)
      );
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: PerformerInfoEntry) {
      _instance.key = _instance.key || 0;
      _instance.value = _instance.value || undefined;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: PerformerInfoEntry,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.key = _reader.readInt32();
            break;
          case 2:
            _instance.value = new booking_platformV1Entertainment026.PerformerInfoEntity();
            _reader.readMessage(
              _instance.value,
              booking_platformV1Entertainment026.PerformerInfoEntity
                .deserializeBinaryFromReader
            );
            break;
          default:
            _reader.skipField();
        }
      }

      PerformerInfoEntry.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(
      _instance: PerformerInfoEntry,
      _writer: BinaryWriter
    ) {
      if (_instance.key) {
        _writer.writeInt32(1, _instance.key);
      }
      if (_instance.value) {
        _writer.writeMessage(
          2,
          _instance.value as any,
          booking_platformV1Entertainment026.PerformerInfoEntity
            .serializeBinaryToWriter
        );
      }
    }

    private _key: number;
    private _value?: booking_platformV1Entertainment026.PerformerInfoEntity;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of PerformerInfoEntry to deeply clone from
     */
    constructor(_value?: RecursivePartial<PerformerInfoEntry.AsObject>) {
      _value = _value || {};
      this.key = _value.key;
      this.value = _value.value
        ? new booking_platformV1Entertainment026.PerformerInfoEntity(
            _value.value
          )
        : undefined;
      PerformerInfoEntry.refineValues(this);
    }
    get key(): number {
      return this._key;
    }
    set key(value: number) {
      this._key = value;
    }
    get value():
      | booking_platformV1Entertainment026.PerformerInfoEntity
      | undefined {
      return this._value;
    }
    set value(
      value: booking_platformV1Entertainment026.PerformerInfoEntity | undefined
    ) {
      this._value = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      PerformerInfoEntry.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): PerformerInfoEntry.AsObject {
      return {
        key: this.key,
        value: this.value ? this.value.toObject() : undefined
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): PerformerInfoEntry.AsProtobufJSON {
      return {
        key: this.key,
        value: this.value ? this.value.toProtobufJSON(options) : null
      };
    }
  }
  export module PerformerInfoEntry {
    /**
     * Standard JavaScript object representation for PerformerInfoEntry
     */
    export interface AsObject {
      key: number;
      value?: booking_platformV1Entertainment026.PerformerInfoEntity.AsObject;
    }

    /**
     * Protobuf JSON representation for PerformerInfoEntry
     */
    export interface AsProtobufJSON {
      key: number;
      value: booking_platformV1Entertainment026.PerformerInfoEntity.AsProtobufJSON | null;
    }
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.MercuryHubBookingDetail.DiningInfoEntry
   */
  export class DiningInfoEntry implements GrpcMessage {
    static id =
      'ten.grpc.booking_service.dto.MercuryHubBookingDetail.DiningInfoEntry';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new DiningInfoEntry();
      DiningInfoEntry.deserializeBinaryFromReader(
        instance,
        new BinaryReader(bytes)
      );
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: DiningInfoEntry) {
      _instance.key = _instance.key || 0;
      _instance.value = _instance.value || undefined;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: DiningInfoEntry,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.key = _reader.readInt32();
            break;
          case 2:
            _instance.value = new booking_platformV1Dining027.VenueDetailsEntity();
            _reader.readMessage(
              _instance.value,
              booking_platformV1Dining027.VenueDetailsEntity
                .deserializeBinaryFromReader
            );
            break;
          default:
            _reader.skipField();
        }
      }

      DiningInfoEntry.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(
      _instance: DiningInfoEntry,
      _writer: BinaryWriter
    ) {
      if (_instance.key) {
        _writer.writeInt32(1, _instance.key);
      }
      if (_instance.value) {
        _writer.writeMessage(
          2,
          _instance.value as any,
          booking_platformV1Dining027.VenueDetailsEntity.serializeBinaryToWriter
        );
      }
    }

    private _key: number;
    private _value?: booking_platformV1Dining027.VenueDetailsEntity;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of DiningInfoEntry to deeply clone from
     */
    constructor(_value?: RecursivePartial<DiningInfoEntry.AsObject>) {
      _value = _value || {};
      this.key = _value.key;
      this.value = _value.value
        ? new booking_platformV1Dining027.VenueDetailsEntity(_value.value)
        : undefined;
      DiningInfoEntry.refineValues(this);
    }
    get key(): number {
      return this._key;
    }
    set key(value: number) {
      this._key = value;
    }
    get value(): booking_platformV1Dining027.VenueDetailsEntity | undefined {
      return this._value;
    }
    set value(
      value: booking_platformV1Dining027.VenueDetailsEntity | undefined
    ) {
      this._value = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      DiningInfoEntry.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): DiningInfoEntry.AsObject {
      return {
        key: this.key,
        value: this.value ? this.value.toObject() : undefined
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): DiningInfoEntry.AsProtobufJSON {
      return {
        key: this.key,
        value: this.value ? this.value.toProtobufJSON(options) : null
      };
    }
  }
  export module DiningInfoEntry {
    /**
     * Standard JavaScript object representation for DiningInfoEntry
     */
    export interface AsObject {
      key: number;
      value?: booking_platformV1Dining027.VenueDetailsEntity.AsObject;
    }

    /**
     * Protobuf JSON representation for DiningInfoEntry
     */
    export interface AsProtobufJSON {
      key: number;
      value: booking_platformV1Dining027.VenueDetailsEntity.AsProtobufJSON | null;
    }
  }
}
